/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-13 14:41:07
 * @LastEditTime: 2022-01-14 10:07:26
 * @LastEditors: zhao - 🍉
 * @Description: 合同审核
 * @FilePath: /zhzj-admin/src/page/RentContract/review.jsx
 */
import React, {useRef} from "react";
import { fetchRentContractApplyList } from "../../services/rentContractApply";
import TableHelper from "../../components/TableHelper";
import PageWrap from "../../components/PageWrap";
import {
    capitalChannelIsMap, contractSource,
    contractType,
    dicContractSource,
    dicRentContractRentStatus,
    mapRentContractApprovalStatus,
    mapRentContractApprovalType
} from "../../axios/dictionaries";
import {findDict, formatTime, moneyAddComma} from "../../utils";
import RentContractApproval from "./components/ContractApproval";
import RentContractReviewDetail from "./components/ContractReviewDetail";
import moment from "moment";
import {Divider} from "antd";
const ContractReview = () => {
   let RentContractApprovalRef = useRef()
   let RentContractReviewDetailRef = useRef()
    const tabsOptions = [
        { key: 'applyStatus', options: mapRentContractApprovalStatus, },
    ]
    const searchOptions = [
        { key: 'buildingName', type: 'input', placeholder: '小区楼栋',},
        { key: 'roomNo', type: 'input', placeholder: '房号', },
        { key: 'merchantName', type: 'input', placeholder: '商户名称'},
        { key: 'projectName', type: 'input', placeholder: '项目名称',},
        { key: 'keyword', type: 'input', placeholder: '关键字',},
        { key: 'approvalDateStart', type: 'date', placeholder: '审批日始',},
        { key: 'approvalDateEnd', type: 'date', placeholder: '审批日末',},
        { key: 'beginDateEnd', type: 'date', placeholder: '合同起租日末',},
        { key: 'beginDateStart', type: 'date', placeholder: '合同起租日始',},
    ]
    const columns = [
        {
            title: '合同类型 | 租赁类型',
            dataIndex: 'contractSource',
            render(text, record, index) {
                let contract = contractSource.find(item => item.value === record.contractSource);
                return <span>
                      <div >{findDict(contractType, record.contractType).title}</div>
                    <div style={{ color: contract.color }}>{contract.title}</div>
                </span>
            }
        },
        {
            title: '房源',
            dataIndex: 'houseId',
            render(text, record, index) {
                return <span>
                <div>{record.roomNo ? record.roomNo : ''}</div>
                <div>{record.buildingName ? record.buildingName : ''}</div>
            </span>
            }
        },
        {
            title: '租客',
            dataIndex: 'customerName',
            render(text, record, index) {
                return <span>
                <div>{record.customerName ? record.customerName : ""}</div>
                <div>{record.customerPhone ? record.customerPhone : ""}</div>
            </span>
            }
        },
        {
            title: '合同周期',
            dataIndex: 'n34ame',
            render(text, record, index) {
                return <span>
                <div>{record.beginDate ? moment(record.beginDate).format('YYYY-MM-DD') : ''}</div>
                <div>{record.endDate ? moment(record.endDate).format('YYYY-MM-DD') : ''}</div>
            </span>
            }

        },
        {
            title: '租金（元）',
            dataIndex: 'monthlyFee',
            align: 'right',
            render(text, record, index) {
                return <span style={{ textAlign: "right" }}>
                <div>{moneyAddComma(record.monthlyFee)}</div>
            </span>
            }
        },
        {
            title: '申请人 | 时间',
            dataIndex: 'name32',
            render(text, record, index) {
                return <span>
                <div>{record.createMerchantUserName ? record.createMerchantUserName : ""}</div>
                    {
                        record.createTime
                            ? <React.Fragment>
                                <div>{record.createTime ? moment(record.createTime).format('YYYY-MM-DD HH:mm') : ''}</div>
                            </React.Fragment>
                            : null
                    }
            </span>
            }
        },
        { title: '审核类型', dataIndex: 'approvalType', render: (text) => {
            return findDict(mapRentContractApprovalType, text).title
        }},
        { title: '审核状态 | 审核时间', dataIndex: 'approvalTime', render(text, record, index) {
                return <span>
                <div>{findDict(mapRentContractApprovalStatus, record.applyStatus).title}</div>
                    {
                        record.approvalTime
                            ? <React.Fragment>
                                <div>{record.approvalTime ?((record.approvalUserName?(record.approvalUserName+" | "):"")+moment(record.approvalTime).format('YYYY-MM-DD HH:mm')) : ''}</div>
                            </React.Fragment>
                            : null
                    }
            </span>
            }},
        {
            title: '商户 | 项目',
            dataIndex: 'name12',

            render(text, record, index) {
                return <span>
                <div>{record.shortName}</div>
                    {
                        record.projectName
                            ? <React.Fragment>
                                <div>{record.projectName}</div>
                            </React.Fragment>
                            : null
                    }
            </span>
            }

        },
        { title: '审核备注信息', dataIndex: 'approvalRemark', },
        {title: '操作', dataIndex: 'actions', fixed: 'right', render: (text, record) => {
            return <React.Fragment>
                <a onClick={() => RentContractReviewDetailRef.open(record.id)}>详情</a>
                <Divider type="vertical" />
                {record.applyStatus==1?<a onClick={() => RentContractApprovalRef.current.open(record.id)}>审批</a>:null}
            </React.Fragment>
        }}
    ]
    return (
        <PageWrap>
            <TableHelper 
                tabsOptions={tabsOptions} 
                searchOptions={searchOptions} 
                columns={columns} 
                request={fetchRentContractApplyList} 
                scroll={{x: 2500}}
            />
            <RentContractApproval ref={ref => RentContractApprovalRef.current = ref} />
            <RentContractReviewDetail getRef={ref => RentContractReviewDetailRef = ref } />
        </PageWrap>
    )
}
export default ContractReview


// WEBPACK FOOTER //
// ./src/page/RentContract/review.jsx